module.exports = __webpack_public_path__ + "static/media/PDFTron_Logo.5bcd56d5.svg";